import React from 'react';
import HeroHeader from './HeroHeader';
import HeroSearch from './HeroSearch';
import Search from './Search';
import './Hero.css';

const HeroElement = props => {
  console.log("heroElement props", props);
  return (
    <>
      <HeroHeader appName="CineView" appSlug="Real People. Real Reviews." />
      <div className="landing-page-route-wrapper">
        <HeroSearch
          {...props}
          id="hero-input"
          searchHandler={props.searchHandler}
          searchCriteria={props.searchCriteria}
          handleChange={props.handleChange}
          randomTitle={props.randomTitle}
          label="Search for Movies:"
        />
      </div>

        <Search 
            className={props.className}
            getReleaseYear={props.getReleaseYear}
            headerLabel="Search Results:"
            searchCriteria={props.searchCriteria}
            searchResults={props.searchResults}
        />
    </>
  );
};

export default HeroElement;
